import React from "react";
import { resolveTenantBrand } from "../config/tenantBranding";

export default function BrandHomeLink({
  brand: suppliedBrand,
  className,
  children,
  ariaLabel,
  title,
}) {
  const brand = suppliedBrand || resolveTenantBrand();
  const homeUrl = brand.homeUrl || "https://clikkle.com";

  return (
    <a
      className={className}
      href={homeUrl}
      aria-label={ariaLabel || `Go to ${brand.name} home`}
      title={title || `Go to ${brand.name} home`}
    >
      {children}
    </a>
  );
}
